import { render, staticRenderFns } from "./TeamRequests.vue?vue&type=template&id=2ff3bb1c&scoped=true"
import script from "./teamRequests.ts?vue&type=script&lang=ts&external"
export * from "./teamRequests.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequests.vue?vue&type=style&index=0&id=2ff3bb1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3bb1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff3bb1c')) {
      api.createRecord('2ff3bb1c', component.options)
    } else {
      api.reload('2ff3bb1c', component.options)
    }
    module.hot.accept("./TeamRequests.vue?vue&type=template&id=2ff3bb1c&scoped=true", function () {
      api.rerender('2ff3bb1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/client/team-requests/TeamRequests.vue"
export default component.exports